var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlue2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 309,
    height: 344,
    viewBox: "0 0 309 344",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.191 244.238C-26.8969 179.12 2.14404 91.6318 82.9156 32.4753C133.658 -37.9825 217.199 22.732 276.287 87.8498C335.375 152.968 303.341 244.611 252.599 315.069C201.857 385.527 91.279 309.355 32.191 244.238Z",
    fill: "#002668"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlue2);
export default __webpack_public_path__ + "static/media/blue-2.f93dc19644b57f9c9c431982cc826e7f.svg";
export { ForwardRef as ReactComponent };